<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    destroy-on-close
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      :rules="rules"
      ref="editForm"
    >
      <el-row>
        <el-form-item label="名称" prop="name">
          <el-input
            size="small"
            v-model="editForm.name"
            auto-complete="off"
            placeholder="名称"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="URL" prop="url">
          <el-input
            size="small"
            v-model="editForm.url"
            auto-complete="off"
            placeholder="URL"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="权限标识" prop="perms">
          <el-input
            size="small"
            v-model="editForm.perms"
            auto-complete="off"
            placeholder="权限标识"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-form-item label="父级菜单" prop="parentName">
        <el-input
          size="small"
          v-model="editForm.parentName"
          auto-complete="off"
          placeholder="父级菜单"
          readonly
        >
          <el-button slot="append" type="primary" @click="handleParent"
            >请选择</el-button
          ></el-input
        >
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-select
          size="small"
          v-model="editForm.type"
          placeholder="请选择"
          @change="handleTypeChange"
        >
          <el-option label="目录" value="0"></el-option>
          <el-option label="菜单" value="1"></el-option>
          <el-option label="按钮" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排序" prop="orderNum">
        <el-input
          size="small"
          v-model="editForm.orderNum"
          auto-complete="off"
          placeholder="排序"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          type="textarea"
          size="small"
          v-model="editForm.remark"
          auto-complete="off"
          placeholder="备注"
        ></el-input>
      </el-form-item>
    </el-form>
    <Menu :visible.sync="visibleMenu" @confirm="handleConfirm"></Menu>
    <div slot="footer">
      <el-button size="small" type="primary" @click="handleSubmit"
        >确定</el-button
      >
      <el-button size="small" @click="handleClose">返回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveOrUpdateMenu } from "@/api/system/menu";
import Menu from "./menu.vue";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    editForm: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  },
  components: {
    Menu,
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入菜单名称" }],
        parentName: [
          { required: true, message: "请选择上级菜单", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择类型" }],
        orderNum: [{ required: true, message: "请输入排序" }],
      },
      visibleMenu: false,
    };
  },
  methods: {
    handleTypeChange(type) {
      switch (type) {
        // 目录
        case "0":
          this.rules = {
            name: [{ required: true, message: "请输入菜单名称" }],
            parentName: [
              { required: true, message: "请选择上级菜单", trigger: "blur" },
            ],
            type: [{ required: true, message: "请选择类型" }],
            orderNum: [{ required: true, message: "请输入排序" }],
          };
          break;
        // 菜单
        case "1":
          this.rules = {
            name: [{ required: true, message: "请输入菜单名称" }],
            parentName: [
              { required: true, message: "请选择上级菜单", trigger: "blur" },
            ],
            type: [{ required: true, message: "请选择类型" }],
            orderNum: [{ required: true, message: "请输入排序" }],
            url: [{ required: true, message: "请输入菜单路径" }],
          };
          break;
        // 按钮
        case "2":
          this.rules = {
            name: [{ required: true, message: "请输入菜单名称" }],
            parentName: [
              { required: true, message: "请选择上级菜单", trigger: "blur" },
            ],
            type: [{ required: true, message: "请选择类型" }],
            orderNum: [{ required: true, message: "请输入排序" }],
            perms: [{ required: true, message: "请输入权限标识" }],
          };
          break;
        default:
          this.rules = {
            name: [{ required: true, message: "请输入菜单名称" }],
            parentName: [
              { required: true, message: "请选择上级菜单", trigger: "blur" },
            ],
            type: [{ required: true, message: "请选择类型" }],
            orderNum: [{ required: true, message: "请输入排序" }],
          };
          break;
      }
    },
    handleParent() {
      this.visibleMenu = true;
    },
    handleConfirm(data) {
      this.editForm.parentId = data.id;
      this.editForm.parentName = data.name;
      this.$emit("update:editForm", this.editForm);
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          saveOrUpdateMenu(this.editForm)
            .then(() => {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.message,
                type: "error",
              });
            });
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>







// WEBPACK FOOTER //
// src/views/system/menu/add-edit/index.vue